<div
  class="wrapper"
  >

  @if (changeableParameters == null || changeableParameters.length === 0) {
    <div class="no-parameters">
      {{'musicChannel.musicCollection.tweak.noTweaks' | translate}}
    </div>
  }

  @for (param of changeableParameters; track param; let i = $index; let last = $last) {
    <div
      class="field-container"
      [class.bottom-space]="last"
      >
      <tun-scrollable-text class="title" [text]="param.name | uppercase"></tun-scrollable-text>
      @if (isCheckboxSelectionParameter(param)) {
        <div class="field checkboxes">
          @for (val of param.value; track val) {
            <button
              class="checkboxButton {{changeableParametersColor}}"
              [class.checked]="val.selected === undefined ? true : val.selected"
              (click)="onToggleValue(val)">
              {{val.value}}
            </button>
          }
        </div>
      }
      @if (isSliderRangeSelectionParameter(param)) {
        <div class="field">
          <tun-text-slider-v5
            [options]="param | mapSliderOptionsV5"
            [sliderColor]="changeableParametersColor"
            [selectedMinValue]="minSelectedValue(param)"
            [selectedMaxValue]="maxSelectedValue(param)"
            (selectedMinValueEmitter)="adjustMinValue(param, $event)"
            (selectedMaxValueEmitter)="adjustMaxValue(param, $event)"
            >
          </tun-text-slider-v5>
        </div>
      }
      @if (isSingleLabelTextSliderParameter(param)) {
        <div class="field">
          <tun-text-slider-v5
            [options]="param | mapSliderOptionsV5"
            [sliderColor]="changeableParametersColor"
            [selectedMinValue]="param.lowerSelection"
            [selectedMaxValue]="param.upperSelection"
            [isSingleLabel]="true"
            [label]="param.name"
            (selectedMinValueEmitter)="adjustMinValue(param, $event)"
            (selectedMaxValueEmitter)="adjustMaxValue(param, $event)"
            >
          </tun-text-slider-v5>
        </div>
      }
      @if (isFlexibleSliderParameter(param)) {
        <div
          class="field flexible-slider"
          >
          <tun-flexible-slider-v5
            [sliderColor]="changeableParametersColor"
            [minValue]="param.minimum"
            [maxValue]="param.maximum"
            [selectedMinValue]="param.lowerSelection"
            [selectedMaxValue]="param.upperSelection"
          [label]="
            param.metadataDisplayName === 'year'
              ? ''
              : param.metadataDisplayName
          "
            (selectedMinValueEmitter)="adjustMinValue(param, $event)"
            (selectedMaxValueEmitter)="adjustMaxValue(param, $event)"
            >
          </tun-flexible-slider-v5>
        </div>
      }
    </div>
  }
</div>
